import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';
import { WorkflowState, Week } from '../types';

export function useWorkflowStatus() {
  return useQuery<WorkflowState>({
    queryKey: ['workflow', 'status'],
    queryFn: () => api.get('/workflow/status').then((r) => r.data),
    refetchInterval: 30_000,
  });
}

export function useWeeks() {
  return useQuery<{ weeks: Week[] }>({
    queryKey: ['workflow', 'weeks'],
    queryFn: () => api.get('/workflow/weeks').then((r) => r.data),
  });
}

export function usePendingWeeks() {
  return useQuery<{ weeks: Week[] }>({
    queryKey: ['workflow', 'pending'],
    queryFn: () => api.get('/workflow/pending').then((r) => r.data),
    refetchInterval: 15_000,
  });
}

export function useCreateWeek() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { week_start?: string }) =>
      api.post('/workflow/weeks', data).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['workflow'] });
    },
  });
}

export function useApproveStage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (weekId: string) =>
      api.post(`/workflow/approve/${weekId}`).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['workflow'] });
    },
  });
}

export function useRejectStage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ weekId, feedback }: { weekId: string; feedback: string }) =>
      api.post(`/workflow/reject/${weekId}`, { feedback }).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['workflow'] });
    },
  });
}
